import styled from "styled-components";

export const SelectWrapper = styled.div`
  margin: 0px;
  min-width: 120px;
`;
